export const asAngleDown = {
  data: `<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.42188 4.73438L0.234375 1.54688C0 1.3125 0 0.960938 0.234375 0.75L0.75 0.210938C0.984375 0 1.33594 0 1.54688 0.210938L3.79688 2.48438L6.07031 0.210938C6.28125 0 6.63281 0 6.86719 0.210938L7.38281 0.75C7.61719 0.960938 7.61719 1.3125 7.38281 1.54688L4.19531 4.73438C3.98438 4.94531 3.63281 4.94531 3.42188 4.73438Z" fill="currentColor"/>
</svg>

`,
  name: 'angleDown',
};
